import React from "react";
import { Container, Skeleton, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { columns } from "./deliverersReturnsHeaders.js";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import styles from "./lotsReturnsTableStyles.js";

const DeliverersReturnsTable = ({
  guides = [],
  isLoading,
  selectionReturnsModel,
  setSelectionReturnsModel,
}) => {

  const rows = guides?.map((guide, index) => ({
    id: guide.id_guide,
    tracking_code: guide.tracking_code,
    business: guide.business,
    reasons_return: guide.reasons_return,
    recipient_name: guide.recipient_name,
  }));

  const handleSelectionChange = (newSelection) => {
    setSelectionReturnsModel(newSelection);
    //setHasReturnGuidesSelected(newSelection.length > 0);
  };

  return (
    <Container sx={styles.mainContainer} style={{ padding: "0" }}>
      {isLoading ? (
        <Container sx={styles.skeletonMainContainer}>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'10%'} height={40} />
            <Skeleton variant="rounded" width={'20%'} height={40} />
            <Skeleton variant="rounded" width={'20%'} height={40} />
            <Skeleton variant="rounded" width={'25%'} height={40} />
            <Skeleton variant="rounded" width={'25%'} height={40} />
          </Container>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'10%'} height={300} />
            <Skeleton variant="rounded" width={'20%'} height={300} />
            <Skeleton variant="rounded" width={'20%'} height={300} />
            <Skeleton variant="rounded" width={'25%'} height={300} />
            <Skeleton variant="rounded" width={'25%'} height={300} />
          </Container>
        </Container>
      ) : (
        <DataGrid
          autoHeight
          disableColumnFilter
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          rowSelectionModel={selectionReturnsModel}
          onSelectionModelChange={handleSelectionChange}
          getRowHeight={() => 'auto'} 
          sx={{
            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { 
              py: '8px', 
              display: 'flex', 
              alignItems: 'center' 
            },
            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { 
              py: '6px', 
              display: 'flex', 
              alignItems: 'center' 
            },
            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { 
              py: '22px', 
              display: 'flex', 
              alignItems: 'center' 
            },
          }}
          checkboxSelection
          pageSizeOptions={[10, 20, 50, 100]}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          onRowSelectionModelChange={handleSelectionChange}
          isRowSelectable={(params) =>
            params.row.latitude !== 0 && params.row.longitude !== 0
          }
          localeText={{
            noRowsLabel: (
              <NoResultsComponent message={"No se encontrarón guías"} />
            ),
          }}
        />
      )}
    </Container>
  );
};

const NoResultsComponent = ({ message }) => (
  <Container sx={styles.noDataContainer}>
    <SearchOffIcon sx={styles.noDataIcon} />
    <Typography sx={styles.noDataTitle}>{message}</Typography>
  </Container>
);

export default DeliverersReturnsTable;
